/**
 * 一镜的 fact 徽标取文规则 —— 矮卡绿标(VideoShotStrip)/ 检视器「这一镜在讲」
 * (VideoShotInspector)共用同一条取文口径,别各写一份(W4 批,2026-09-13)。
 *
 * 文字 = 第一个 fid 的 factTexts 截 6 字,多 fact 加「+N」;factTexts 缺映射显 fid 本身。
 * factRef 空/未传 → null(整块不显,由调用方判)。
 */
export function shotFactChipLabel(
  factRef: string[] | null | undefined,
  factTexts?: Record<string, string> | null
): string | null {
  if (!factRef || factRef.length === 0) return null;
  const first = factRef[0];
  const raw = factTexts?.[first] ?? first;
  const truncated = raw.length > 6 ? raw.slice(0, 6) : raw;
  const extra = factRef.length > 1 ? `+${factRef.length - 1}` : "";
  return `${truncated}${extra}`;
}
